import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
const phrases = ["Pour les créateurs fatigués des algorithmes.", "Pour les coachs qui veulent remplir leurs sessions et webinaires.", "Pour les communautés qui ont besoin d'annonces immédiates.", "Pour les formateurs lassés des taux d'ouverture à 15%.", "Pour les commerçants qui veulent attirer des clients au bon moment.", "Pour les marques qui cherchent un canal direct et efficace."];
export function TypingSubtitle() {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const currentPhrase = phrases[currentPhraseIndex];
  const handleTyping = useCallback(() => {
    if (!isDeleting) {
      // Typing
      if (displayText.length < currentPhrase.length) {
        setDisplayText(currentPhrase.slice(0, displayText.length + 1));
      } else {
        // Pause at end then start deleting
        setTimeout(() => setIsDeleting(true), 2000);
      }
    } else {
      // Deleting
      if (displayText.length > 0) {
        setDisplayText(displayText.slice(0, -1));
      } else {
        // Move to next phrase
        setIsDeleting(false);
        setCurrentPhraseIndex(prev => (prev + 1) % phrases.length);
      }
    }
  }, [displayText, currentPhrase, isDeleting]);
  useEffect(() => {
    const typingSpeed = isDeleting ? 30 : 50;
    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [handleTyping, isDeleting]);
  return <p className="text-lg md:text-xl text-[#022226] font-semibold min-h-[5.5rem] md:min-h-[2rem]">
      <span className="bg-[#91d0d8]/30 px-1.5 py-0.5 rounded-md transition-all duration-75 text-xl mb-[10px] pb-[2px]" style={{
      boxDecorationBreak: 'clone',
      WebkitBoxDecorationBreak: 'clone'
    }}>
        {displayText}
      </span>
      <motion.span animate={{
      opacity: [1, 0]
    }} transition={{
      duration: 0.5,
      repeat: Infinity,
      repeatType: "reverse"
    }} className="inline-block w-[2px] h-6 bg-primary ml-1 align-middle" />
    </p>;
}